import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormArray, FormControl } from '@angular/forms';

import { NVP } from '../../shared/nvp';
import { DescriptorFormControl } from '../../descriptor/descriptor-form-control';
import { DescriptorOption } from '../../descriptor/descriptor-option';
import { Subscription } from 'rxjs';
import { LovService } from '../../services/lov.service';

@Component({
  selector: 'vedrax-multiple',
  templateUrl: './vedrax-multiple.component.html',
  styleUrls: ['./vedrax-multiple.component.scss']
})
export class VedraxMultipleComponent implements OnInit, OnDestroy {

  private subscription: Subscription = new Subscription();

  /**
   * The form
   */
  @Input() form: FormGroup = new FormGroup({});

  /**
   * The form control descriptor
   */
  @Input() descriptor: DescriptorFormControl = new DescriptorFormControl();

  /**
   * Emit number of options when all of them are available
   */
  @Output() isReady: EventEmitter<number> = new EventEmitter();

  /**
   * The options
   */
  options: DescriptorOption[] = [];

  /**
   * Is selectable
   */
  selectable = true;

  /**
   * Is removable
   */
  removable = true;

  constructor(private lovService: LovService) { }

  /**
   * List of selected value
   */
  selections: NVP[] = [];

  ngOnInit(): void {
    this.init();
  }

  /**
   * Init method
   */
  private init(): void {

    this.subscription.add(this.lovService.getOptionsFromControlDescriptor(this.descriptor)
      .subscribe(options => {
        this.options = options;
        //emit nb of options
        this.isReady.emit(options.length);
        //copy in control options in case we need that in other part
        if(!this.descriptor.controlOptions){
          this.descriptor.controlOptions = options;
        }
      }));

    const keys: any[] = this.formArray.value || [];

    keys.forEach(key => {

      const nvp = this.toNvp(key);

      if (nvp) {
        this.selections.push(nvp);
      }

    });

  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Method for getting NVP if any
   * @param id 
   * @returns 
   */
  private toNvp(id: string | number = '') {
    const options = this.descriptor.controlOptions || [];
    return options.find(item => item.key === id);
  }

  /**
   * Get declared array of controls
   */
  get formArray(): FormArray {
    return this.form.get(this.descriptor.controlName) as FormArray;
  }

  /**
   * Method triggered on change
   * @param item 
   */
  onChange(item: any) {
    const nvp: NVP = item['value'];
    const idx = this.find(nvp.key);
    if (idx === -1) {
      this.selections.push(nvp);
      this.formArray.push(new FormControl(nvp.key));
    }
  }

  /**
   * Method called when removed
   * @param key 
   */
  remove(key: string | number) {
    const idx = this.find(key);

    if (idx !== -1) {
      this.selections.splice(idx, 1);
      this.formArray.removeAt(idx);
    }
  }

  /**
   * Find selection
   * @param key 
   * @returns 
   */
  private find(key: string | number): number {
    return this.selections.findIndex(selection => selection.key === key);
  }

}
